module.exports = __webpack_public_path__ + "static/media/correct.c884f427.svg";